import React from 'react'
import {
    Typography,
    Grid,
    Container,
    Avatar,
} from '@material-ui/core'
import {
    ArrowBack
} from '@material-ui/icons'
import { VideoPlayer } from 'salvatores'
import { CustomAppBar, CustomButton } from '../../../shared'
import { getContent } from '../../../utils/helper'
import { supportedLanguageMapping } from '../../language/constants'
import { isObject } from 'lodash'

const styles = {
    button: {
        textAlign: 'center',
        width: '100%',
        textTransform: 'none',
        fontWeight: 'normal',
        padding: 0
    }
}

const Preview = ({ goBack, goToScreen, language, languageJSON, selfie, idPhoto, idProofFrontSide, idProofBackSide, addressProofFrontSide, addressProofBackSide, video, submit, homeImage }) => {
    return (
        <div>
            <CustomAppBar title={getContent(languageJSON, 'title_preview')}
                leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
                rightButton={<CustomButton variant="text" color="primary" handleChange={() => goToScreen('language', { to: 'preview' })} label={supportedLanguageMapping[language]} />} />
            <Container style={{ padding: 0 }}>
                <Grid container justify="center" alignItems="center" spacing={2} style={{ padding: '2% 0%', maxHeight: '100vh', overflow: 'scroll', paddingBottom: 150 }}>
                    <Grid item xs={11}>
                        <Typography variant="h6">
                            {getContent(languageJSON, 'subtitle_review_information')}
                        </Typography>
                    </Grid>
                    <Grid item xs={11}>
                        <Grid container justify="center" spacing={2} style={{ marginTop: '2%' }}>

                            <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('selfie', { to: 'preview' })}>
                                <Typography style={{ fontSize: 15, marginBottom: '1%' }}>{getContent(languageJSON, 'title_selfie_photo')}</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={selfie} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" label={getContent(languageJSON, 'action_retake_selfie')} />
                            </Grid>

                            <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('idPhoto', { to: 'preview' })}>
                                <Typography style={{ fontSize: 15, marginBottom: '1%' }}>{getContent(languageJSON, 'title_photoid')}</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={idPhoto} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" label={getContent(languageJSON, 'action_retake_photoid')} />
                            </Grid>

                            <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('idProof', { to: 'preview' })}>
                                <Typography style={{ fontSize: 15, marginBottom: '1%' }}>{getContent(languageJSON, 'title_id_proof')}</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={idProofFrontSide} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" label={getContent(languageJSON, 'action_retake_id_proof')} />
                            </Grid>
                            {/* <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }}>
                                <Typography style={{ fontSize: 12 }}>Id Proof(Back)</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={idProofBackSide} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" handleChange={() => goToScreen('idProof')} label="Retake back side of Id Proof" />
                            </Grid> */}

                            <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('addressProof', { to: 'preview' })}>
                                <Typography style={{ fontSize: 15, marginBottom: '1%' }}>{getContent(languageJSON, 'title_address_proof')}</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={addressProofFrontSide} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" label={getContent(languageJSON, 'action_retake_address_proof')} />
                            </Grid>

                            {/* <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('selfie', { to: 'preview' })}>
                                <Typography style={{ fontSize: 12 }}>Address Proof(Back)</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={addressProofBackSide} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" handleChange={() => goToScreen('selfie')} label="Retake Selfie" />
                            </Grid> */}

                            {homeImage ? <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('homeImage', { to: 'preview' })}>
                                <Typography style={{ fontSize: 15, marginBottom: '1%' }}>{getContent(languageJSON, 'title_home_photo')}</Typography>
                                <Avatar variant="square" style={{ width: '100%', height: '10vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={homeImage} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" label={getContent(languageJSON, 'action_retake_home_image')} />
                            </Grid> : null}

                            <Grid item xs={6} style={{ backgroundColor: '#F1FEF8' }} onClick={() => goToScreen('video', { to: 'preview' })}>
                                <Typography style={{ fontSize: 15, marginBottom: '1%' }}>{getContent(languageJSON, 'title_home_video')}</Typography>
                                <VideoPlayer url={isObject(video) ? video.videoUrl : video} />
                                <CustomButton size="large" variant="contained" style={styles.button} color="secondary" label={getContent(languageJSON, 'action_retake_video')} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Grid container justify="center" alignItems="center" spacing={2} style={{ padding: '15px', position: 'absolute', bottom: 0, left: 0, backgroundColor: '#f7fdfd', margin: 0, width: '100%' }}>
                <Grid item xs={11}>
                    <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', fontSize: 12 }} color="primary" handleChange={submit}
                        label={<Typography variant="button">{getContent(languageJSON, 'action_submit')}</Typography>} />
                </Grid>
            </Grid>
        </div>
    )
}

export default Preview